import { render, staticRenderFns } from "./NearPayOrderDetails.vue?vue&type=template&id=33af3a25&"
import script from "./NearPayOrderDetails.vue?vue&type=script&lang=js&"
export * from "./NearPayOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports